import type { CorridorRoute, CorridorWaypoint, VesselTrack } from '@/types/corridor';

const SHARED_WAYPOINTS: CorridorWaypoint[] = [
  { name: 'Georgetown, Guyana', lat: 6.8, lng: -58.15, type: 'departure' },
  { name: 'Paramaribo, Suriname', lat: 5.85, lng: -55.17, type: 'departure' },
  { name: 'Santa Marta, Colombia', lat: 11.24, lng: -74.2, type: 'departure' },
  { name: 'Praia, Cape Verde', lat: 14.93, lng: -23.51, type: 'transit' },
  { name: 'Las Palmas, Canary Islands', lat: 28.1, lng: -15.41, type: 'transit' },
  { name: 'Ponta Delgada, Azores', lat: 37.75, lng: -25.67, type: 'transit' },
  { name: 'Fort Lauderdale, USA', lat: 26.12, lng: -80.14, type: 'transit' },
  { name: 'San Juan, Puerto Rico', lat: 18.47, lng: -66.1, type: 'transit' },
  { name: 'Portim\u00e3o, Portugal', lat: 37.12, lng: -8.54, type: 'arrival' },
  { name: 'Vigo, Spain', lat: 42.24, lng: -8.72, type: 'arrival' },
  { name: 'C\u00e1diz, Spain', lat: 36.53, lng: -6.29, type: 'arrival' },
];

export const CORRIDOR_ROUTES: CorridorRoute[] = [
  {
    id: 'route-northern',
    name: 'Northern Route',
    type: 'northern',
    geojson: {
      type: 'Feature',
      properties: {
        name: 'Northern Route',
        color: '#FF6B6B',
      },
      geometry: {
        type: 'LineString',
        coordinates: [
          [-57.0, 6.5],
          [-45.0, 12.0],
          [-35.0, 20.0],
          [-28.0, 33.0],
          [-25.5, 37.8],
          [-9.1, 38.7],
        ],
      },
    },
    waypoints: SHARED_WAYPOINTS.filter((wp) =>
      ['Georgetown, Guyana', 'Paramaribo, Suriname', 'Ponta Delgada, Azores', 'Portim\u00e3o, Portugal', 'Vigo, Spain'].includes(wp.name),
    ),
  },
  {
    id: 'route-central',
    name: 'Central Route / "Highway 10"',
    type: 'central',
    geojson: {
      type: 'Feature',
      properties: {
        name: 'Central Route / "Highway 10"',
        color: '#FFD93D',
      },
      geometry: {
        type: 'LineString',
        coordinates: [
          [-55.2, 5.8],
          [-45.0, 8.0],
          [-35.0, 10.0],
          [-24.0, 16.0],
          [-18.0, 28.0],
          [-15.4, 28.1],
        ],
      },
    },
    waypoints: SHARED_WAYPOINTS.filter((wp) =>
      ['Paramaribo, Suriname', 'Praia, Cape Verde', 'Las Palmas, Canary Islands', 'C\u00e1diz, Spain'].includes(wp.name),
    ),
  },
  {
    id: 'route-southern',
    name: 'Southern Route',
    type: 'southern',
    geojson: {
      type: 'Feature',
      properties: {
        name: 'Southern Route',
        color: '#6BCB77',
      },
      geometry: {
        type: 'LineString',
        coordinates: [
          [-48.5, -1.5],
          [-38.0, 0.0],
          [-25.0, 2.0],
          [-15.0, 5.0],
          [-5.0, 5.5],
          [-2.0, 6.0],
        ],
      },
    },
    waypoints: SHARED_WAYPOINTS.filter((wp) =>
      ['Santa Marta, Colombia', 'Georgetown, Guyana'].includes(wp.name),
    ),
  },
];

export const MV_UNITED_S_TRACK: VesselTrack = {
  id: 'vessel-mv-united-s',
  vessel_name: 'MV United S',
  imo: undefined,
  geojson: {
    type: 'Feature',
    properties: {
      name: 'MV United S',
      color: '#FF4444',
    },
    geometry: {
      type: 'LineString',
      coordinates: [
        [34.6, 36.8],
        [13.1, 32.9],
        [-7.6, 33.6],
        [-5.4, 36.0],
        [-25.0, 20.0],
        [-38.5, -3.7],
        [-48.5, -1.45],
        [-55.0, 5.5],
        [-35.0, 12.0],
        [-25.0, 18.0],
        [-18.5, 27.0],
      ],
    },
  },
  waypoints: [
    { name: 'Mersin, Turkey', lat: 36.8, lng: 34.6 },
    { name: 'Tripoli, Libya', lat: 32.9, lng: 13.1 },
    { name: 'Casablanca, Morocco', lat: 33.6, lng: -7.6 },
    { name: 'Strait of Gibraltar', lat: 36.0, lng: -5.4 },
    { name: 'Mid-Atlantic', lat: 20.0, lng: -25.0 },
    { name: 'Fortaleza, Brazil', lat: -3.7, lng: -38.5 },
    { name: 'Bel\u00e9m, Brazil', lat: -1.45, lng: -48.5 },
    { name: 'Near Suriname', lat: 5.5, lng: -55.0, event: 'cocaine loaded' },
    { name: 'Mid-Atlantic (eastbound)', lat: 12.0, lng: -35.0 },
    { name: 'Mid-Atlantic (NE)', lat: 18.0, lng: -25.0 },
    { name: 'Intercepted SW of Canaries', lat: 27.0, lng: -18.5, event: 'intercepted' },
  ],
};
